<template>
  <div class="page-container">
    <div class="doc-wrapper">
      <h1 class="main-title">{{ txt.title }}</h1>
      <div class="meta-info">{{ txt.subtitle }}</div>

      <section class="doc-section">
        <h2>1. {{ txt.origin.title }}</h2>
        <p>{{ txt.origin.p1 }}</p>
        <p>{{ txt.origin.p2 }}</p>
        <div class="quote-box">
          "{{ txt.origin.quote }}"
        </div>
        <p>{{ txt.origin.p3 }}</p>
      </section>

      <section class="doc-section">
        <h2>2. {{ txt.utility.title }}</h2>
        <ul class="dense-list">
          <li><strong>{{ txt.utility.l1_t }}:</strong> {{ txt.utility.l1_d }}</li>
          <li><strong>{{ txt.utility.l2_t }}:</strong> {{ txt.utility.l2_d }}</li>
          <li><strong>{{ txt.utility.l3_t }}:</strong> {{ txt.utility.l3_d }}</li>
        </ul>
      </section>

      <section class="doc-section">
        <h2>3. {{ txt.dist.title }}</h2>
        <p>{{ txt.dist.p1 }}</p>
        <div class="table-wrap">
          <table>
            <thead><tr><th>{{ txt.tbl.cat }}</th><th>{{ txt.tbl.alloc }}</th><th>{{ txt.tbl.desc }}</th></tr></thead>
            <tbody>
              <tr><td>{{ txt.tbl.r1_c }}</td><td>40%</td><td>{{ txt.tbl.r1_d }}</td></tr>
              <tr><td>{{ txt.tbl.r2_c }}</td><td>20%</td><td>{{ txt.tbl.r2_d }}</td></tr>
              <tr><td>{{ txt.tbl.r3_c }}</td><td>15%</td><td>{{ txt.tbl.r3_d }}</td></tr>
              <tr><td>{{ txt.tbl.r4_c }}</td><td>25%</td><td>{{ txt.tbl.r4_d }}</td></tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import DICT from '../locales/data.js';

export default {
  props: ['lang'],
  computed: { txt() { return DICT[this.lang].ecosystem || DICT['en'].ecosystem } }
}
</script>

<style scoped>
.page-container { padding: 40px 0 100px; background: #000; min-height: 100vh; color: #ccc; }
.doc-wrapper { max-width: 900px; margin: 0 auto; padding: 40px; background: #0a0b10; border: 1px solid #222; border-radius: 8px; }
.main-title { color: #fff; font-size: 32px; font-weight: 800; margin-bottom: 10px; border-bottom: 1px solid #333; padding-bottom: 20px; }
.meta-info { font-size: 13px; color: #666; margin-bottom: 40px; font-family: monospace; }
.doc-section { margin-bottom: 50px; }
h2 { color: #fff; font-size: 20px; border-left: 3px solid #00D092; padding-left: 15px; margin-bottom: 20px; }
p { font-size: 14px; line-height: 1.8; margin-bottom: 15px; color: #aaa; text-align: justify; }
.quote-box { background: rgba(0,208,146,0.05); border-left: 4px solid #00D092; padding: 20px; margin: 20px 0; font-style: italic; color: #fff; font-size: 15px; }
.dense-list { list-style: none; padding: 0; }
.dense-list li { margin-bottom: 15px; font-size: 14px; line-height: 1.6; border-bottom: 1px solid #1a1a1a; padding-bottom: 10px; }
.dense-list strong { color: #00D092; display: inline-block; margin-right: 5px; }
.table-wrap { width: 100%; overflow-x: auto; }
table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 13px; }
th, td { border: 1px solid #333; padding: 12px; text-align: left; }
th { background: #151515; color: #fff; font-weight: bold; }
td { color: #999; }
@media(max-width: 768px) { .doc-wrapper { padding: 20px; border: none; } }
</style>